import styled from '@emotion/styled';

export const StyledSearchInput = styled.div`
  width: 100%;
  display: flex;
  padding: 10px;
  border: 2px solid ${({ theme }) => theme.palette?.brand?.gray[300]};
  border-radius: 10px;

  input {
    width: 100%;
    height: 100%;
    border: 0;
    outline: 0;
    font-family: 'Inter';
    font-size: 16px;
    line-height: 24px;
    color: ${({ theme }) => theme.palette?.brand.secondary.base};
    font-weight: 500;
  }
`;

export const StyledIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
`;

export const StyledContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export const StyledSpan = styled.span`
  color: ${({ theme }) => theme.palette?.brand.attention[500]};
  margin: 0.6rem 1rem 0;
  height: 1rem;
`;

export const StyledSearchWrapper = styled.div`
  display: flex;
  width: 100%;
`;

export const StyledButtonIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
`;

export const ButtonArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 17px;
  cursor: pointer;
`;
